import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import {
  Container,
  Label,
  InputWrapper,
  Input,
  InputContainer,
  Underline,
  Link,
  PasswordWrapper,
  EyeIcon,
  Message,
  Logomarca,
  Imgs
} from '../styles';
import { login } from '../api';
import { Button, Divider } from '../components';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async () => {
    try {

      const response = await login(username, password);

      if (response.ok) { 
        const data = await response.json();

        // Salva o token no localStorage
        localStorage.setItem('token', data.token); 

        // Navega para a página inicial
        navigate('/home');

      } else if (response.status === 400) {
        setMessage('Credenciais inválidas. Verifique seu e-mail e senha.');

      } else {
        setMessage('Erro ao tentar fazer login. Por favor, tente novamente mais tarde.');
      }

    } catch (error) {
      console.error('Error:', error);
      setMessage('Erro ao tentar fazer login. Por favor, tente novamente mais tarde.');
    }
  };

  const handleSignUp = () => {
    navigate('/register');
  };

  const ForgotPassword = () => {
    navigate('/forgot-password');
  };

  return (
    <Container>
      <InputContainer>
        <Logomarca src={Imgs.logo}  alt="Blue House Tennis" width="200px" height="auto" />
        {message && <Message>{message}</Message>}
        <InputWrapper>
          <Label>USERNAME</Label>
          <Input
            type="text"
            placeholder="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <Underline />
        </InputWrapper>
        <InputWrapper>
          <Label>SENHA</Label>
          <PasswordWrapper>
            <Input
              type={showPassword ? 'text' : 'password'}
              placeholder="●●●●●●●●●●●●"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ fontSize: "14px" }}
            />
            <EyeIcon onClick={togglePasswordVisibility}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </EyeIcon>
          </PasswordWrapper>
          <Underline />
        </InputWrapper>
        <Button onClick={handleLogin} title="LOGIN" />
        <Link onClick={ForgotPassword} href="#">Esqueceu sua senha?</Link>
        <Divider text="OU" />
        <Button onClick={handleSignUp} title="REGISTRE-SE" />
      </InputContainer>
    </Container>
  );
};

export default Login;
